'use client';

import { darkTokens } from '@vk-tech/ui-tokens/lib/VKTechMarketing/ts/dark';
import { lightTokens } from '@vk-tech/ui-tokens/lib/VKTechMarketing/ts/light';
import { ConfigProvider } from '@vk-tech/ui-toolkit';
import { ThemeEntity } from '@vk-tech/ui-toolkit/lib/core/themes/themes.types';
import { useCallback } from 'react';

import { PopupResolver } from '~containers/PopupResolver/PopupResolver';
import { PopupTargetActionEvents } from '~containers/PopupResolver/PopupResolver.types';
import { usePopupManager } from '~hooks/usePopupManager';

type PopupManagerProps = {
  locale: string;
  theme?: string;
};

export function PopupManager({ locale, theme }: PopupManagerProps) {
  const { activePopup, closePopup, handleTargetAction } =
    usePopupManager(locale);

  const handleClose = useCallback(() => {
    closePopup();
  }, [closePopup]);

  if (!activePopup) return null;

  const customTheme = (theme === 'dark'
    ? darkTokens
    : lightTokens) as unknown as ThemeEntity;

  return (
    <ConfigProvider customTheme={customTheme}>
      <PopupResolver
        {...activePopup.props}
        active
        onClose={handleClose}
        onTargetAction={(
          actionValue: string,
          shouldClose?: boolean,
          events?: PopupTargetActionEvents,
        ) =>
          handleTargetAction(activePopup.id, actionValue, {
            shouldClose,
            events,
          })
        }
      />
    </ConfigProvider>
  );
}
